export const characterSpellSlots = [
  {
    index: "Cleric",
    cantrips: 3,
    spells: 1,
  },
  {
    index: "Bard",
    cantrips: 2,
    spells: 4,
  },
  {
    index: "Barbarian",
    cantrips: 0,
    spells: 0,
  },
  {
    index: "Druid",
    cantrips: 2,
    spells: 1,
  },
  {
    index: "Fighter",
    cantrips: 0,
    spells: 0,
  },
  {
    index: "Monk",
    cantrips: 0,
    spells: 0,
  },
  {
    index: "Paladin",
    cantrips: 0,
    spells: 0,
  },
  {
    index: "Ranger",
    cantrips: 0,
    spells: 0,
  },
  {
    index: "Rogue",
    cantrips: 0,
    spells: 0,
  },
  {
    index: "Sorcerer",
    cantrips: 2,
    spells: 2,
  },
  {
    index: "Warlock",
    cantrips: 3,
    spells: 2,
  },
  {
    index: "Wizard",
    cantrips: 3,
    spells: 1,
  },
];
